import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/common";

export default function StageOutput() {
  const { key } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/stages/${encodeURIComponent(key)}/output`).then((r) => setD(r.data)); }, [key]);
  if (!d) return <Loader />;
  const filled = d.sections.filter((s) => s.value).length;
  return (
    <div className="max-w-3xl" data-testid="stage-output-page">
      <div className="flex justify-between items-center mb-4 print:hidden">
        <Link to={`/stage/${encodeURIComponent(key)}`} className="inline-flex items-center gap-1 text-sm font-semibold text-[#5C6B73]" data-testid="output-back-link"><ArrowLeft className="h-4 w-4" /> {key}</Link>
        <button onClick={() => window.print()} className="sb-btn-ghost text-sm min-h-[40px]" data-testid="output-print-btn"><Printer className="h-4 w-4" />Print / PDF</button>
      </div>
      <article className="sb-card p-6 sm:p-10">
        <div className="sb-eyebrow">{key} · Stage output</div>
        <h1 className="text-3xl font-extrabold mt-2" data-testid="output-title">{d.output}</h1>
        <div className="text-sm text-[#5C6B73] mt-1">{d.business} · {filled}/{d.sections.length} sections completed</div>
        <div className="mt-8 space-y-6">
          {d.sections.map((s) => (
            <section key={s.lesson_id} className="border-l-4 pl-4 border-[#EADEC9] data-[filled=true]:border-[#1DB99A]" data-filled={!!s.value}>
              <h2 className="font-display font-bold">{s.label}</h2>
              {s.value ? <p className="text-[15px] mt-1 whitespace-pre-wrap">{s.value}</p>
                : <Link to={`/lesson/${s.lesson_id}`} className="text-sm text-[#179B80] font-semibold mt-1 inline-block">Complete “{s.lesson_title}” to fill this →</Link>}
            </section>
          ))}
        </div>
      </article>
    </div>
  );
}
